import { schema } from 'normalizr';
import permissionSchema from './permissionSchema';

const roleSchema = new schema.Entity('roles', {
  permissions: [permissionSchema],
});

export default roleSchema;
